
export class Agency {
  reference: string;
  name: string;
  address: string;
  email: string;
  phone: string;
  status: string;
  manager: any;
  organization: any;
  city: any;
}





// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/agency/agency.model.ts